var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShowSyncToTTC
    ? _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isShowSyncToTTC,
            title: "铺货到中国土特产",
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowSyncToTTC = $event
            },
            close: _vm.close,
          },
        },
        [
          _c("div", { staticStyle: { "margin-bottom": "12px" } }, [
            _vm._v("商品状态："),
          ]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.ttcIsOnSale,
                callback: function ($$v) {
                  _vm.ttcIsOnSale = $$v
                },
                expression: "ttcIsOnSale",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("上架")]),
              _c("el-radio", { attrs: { label: 0 } }, [_vm._v("下架")]),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "padding-top": "24px" } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.isSubmiting,
                    type: "primary",
                    size: "mini",
                  },
                  on: { click: _vm.submitBtn },
                },
                [_vm._v("确定")]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.close } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }